<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel" width="800"
           :class-name="z100000"
           :class="{'mask':mask}"
    >
      <h3 slot="header" class="modal-header" style="vertical-align: bottom">修改交割信息 <span>{{projectName}}</span> <span class="dot">.</span> <span >{{stockNumber}}</span> </h3>
      <div>
        <h4 class="mb8">生活费用</h4>
        <div>
          <Row class="row">
            <Col span="4">项目类别</Col>
            <Col span="4">智能设备</Col>
            <Col span="4">付费模式</Col>
            <Col span="3">底数</Col>
            <Col span="3">附件</Col>
            <Col span="3">修改附件</Col>
            <Col span="3">备注</Col>
          </Row>
          <Row class="row" v-for="(item,index) in meterListCopy" :key="'keyA'+index">
            <Form :model="item" :inline="true" :rules="item.meterPayType===0?formRules2:formRules" :ref="'form1'+index">
              <Col span="4">{{item.meterTypeName || '-'}}</Col>
              <Col span="4">{{item.isSmartDevice===true?'是':(item.isSmartDevice===false?'否':'-')}}</Col>
              <Col span="4">
                <!--付费模式-->
                <div v-if="item.allowModify">
                  <FormItem  prop="meterPayType" class="notip" style="display: block">

                    <Select v-model="item.meterPayType" >
                      <!--<Option value="">请选择</Option>-->
                      <Option v-for="(item,index) in payTypeList" :value="item.value" :key="'keyB'+index">{{item.text}}
                      </Option>
                    </Select>
                  </FormItem>
                </div>
                <div v-else>{{item.meterPayType===0?'预付费':(item.meterPayType===1?'后付费':'-')}}</div>
              </Col>
              <Col span="3">
                <!--底数-->
                <!--<span v-if="item.isSmartDevice===true">{{item.curMeterDisplay}}</span>-->
                <!--<FormItem v-else prop="curMeterDisplay" class="notip">-->
                  <!--<Input class="inputwidth" v-model="item.curMeterDisplay"/>-->
                <!--</FormItem>-->


                <div v-if="!meterList[index].meterPic">{{item.curMeterDisplay?item.curMeterDisplay:(item.curMeterDisplay===0?0:'-')}}</div>
                <div v-else>
                  <FormItem  prop="curMeterDisplay" class="notip">
                    <Input class="inputwidth" v-model="item.curMeterDisplay"/>
                  </FormItem>
                </div>

              </Col>
              <Col span="3">
                <!--附件-->
                  <a v-if="meterList[index].meterPic" href="javascript:;" @click.stop="showImg(meterList[index].meterPic)">查看</a>
                  <span v-else>无</span>
              </Col>
              <Col span="3">
                <!--修改附件-->
                <!--<div v-if="item.isSmartDevice===true">不支持修改</div>-->
                <div v-if="!meterList[index].meterPic">不支持修改</div>
                <div v-else>
                  <Upload style="display: inline-block;margin-left: 5px"
                          :action="baseUrl+'/file/uploadFile'"
                          :data="{type:index}"
                          :on-success="handleSuccess"
                          :headers="{'Access-Token':token}"
                          :show-upload-list="false"
                          :on-error="handleError"
                          :format="['jpg','jpeg','png']"
                          :on-format-error="formatError"
                  >
                    <a href="javascript:;">{{item.meterPicName||'修改'}}</a>
                  </Upload>
                </div>
              </Col>
              <Col span="3">{{item.remark|| '-'}}</Col>
            </Form>
          </Row>
        </div>
      </div>
      <!--<Table :columns="columns1" :data="data1" ></Table>-->
      <div class="mt36">
        <div class="mb8">
          <h4 style="display: inline-block">房间物品信息</h4>
          <span style="color: red;float: right">物品信息如有缺误，请移步资产管理添加。</span>
        </div>
        <Table :columns="columns2" :data="goodsList"></Table>
      </div>

      <img-show :n="imgN" :src="imgSrc"></img-show>

    </Modal>
  </div>
</template>
<script>
  import {deliverysave, findEntryDeliveryInfo, deliverygoods} from "../../../../api/contractList";
  import {deepClone} from "../../../../utils/format";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import ImgShow from 'components/ImgShow/index'

  export default {
    // name: "",
    components: {
      ImgShow
    },
    props: {
      mask:{
        type:Boolean,
        default:false
      },
      n: {
        type: Number,
        default: 0
      },
      contractId: {
        type: String,
        default: ''
      },
      stockFid: {
        type: String,
        default: ''
      },
      projectName:{
        type: String,
        default: ''
      },
      stockNumber:{
        type: String,
        default: ''
      }
    },
    watch: {
      n() {
        this.meterListCopy = []
        this.meterList = []
        this.goodsList = []
        // this.findDeliveryInfo()
        this.findEntryDeliveryInfo()
        this.deliverygoods()
        this.isShow = true

      }
    },
    data() {
      return {
        imgSrc:'',
        imgN:0,
        formRules: {
          curMeterDisplay: [
            {required: true, message: '', validator: this.validateNumber2, trigger: 'blur'},
          ],
          meterPayType:[
            {required: true, message: '', validator: this.validateNumber, trigger: 'change'},
          ]
        },
        formRules2: {
          curMeterDisplay: [
            {required: true, message: '', validator: this.validateNumber3, trigger: 'blur'},
          ],
          meterPayType:[
            {required: true, message: '', validator: this.validateNumber, trigger: 'change'},
          ]
        },
        token: '',
        baseUrl: '',
        payTypeList: [{text: '预付费', value: 0}, {text: '后付费', value: 1}],
        meterListCopy: [],
        meterList: [],
        goodsList: [],
        z100000: 'z100000',
        loading: true,
        isShow: false,
        columns2: [
          {
            title: "物品",
            key: "goodsName",
            align: "center"
          },
          {
            title: "大类",
            key: "goodsType",
            align: "center"
          },
          {
            title: "数量",
            key: "goodsCount",
            align: "center"
          },
          {
            title: "价格",
            key: "goodsPrice",
            align: "center"
          },
          {
            title: "状态",
            key: "remark",
            align: "center"
          },

        ],
        columns1: [
          {
            title: "项目类别",
            key: "",
            align: "center"
          },
          {
            title: "智能设备",
            key: "",
            align: "center"
          },
          {
            title: "付费模式",
            key: "",
            align: "center"
          },
          {
            title: "底数",
            key: "",
            align: "center"
          },
          {
            title: "附件",
            key: "",
            align: "center"
          },
          {
            title: "备注",
            key: "",
            align: "center"
          },
        ]
      }
    },
    methods: {
      validateNumber3(rule, value, callback) {
        let pattern = /^(-?\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      showImg(src){
        this.imgSrc=src
        this.imgN++
      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      findEntryDeliveryInfo() {
        let params = {
          contractId: this.contractId
        }
        findEntryDeliveryInfo(params).then(res => {
          if(!res.data){
            return
          }
          res.data.forEach(ele => {
            ele['meterPicName'] = ''
          })
          this.meterList = res.data
          this.meterListCopy = deepClone(this.meterList)
        }).catch(error => {
        })

      },
      deliverygoods() {
        let params = {
          stockFid: this.stockFid
        }
        deliverygoods(params).then(res => {
         res.data && ( this.goodsList = res.data)
        }).catch(error => {
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      formatError() {
        this.$Message.info('请上传图片格式(jpg、png、jpeg)文件')
      },
      handleSuccess(res, file) {
        let index = Number(res.data.type)
        this.meterListCopy[index].meterPicName = file.name.length<=10?file.name:file.name.slice(0,10)+'...'
        this.meterListCopy[index].meterPic = res.data.url
      },
      handleError() {
      },
      ok() {
        // console.log(this)
        //校验输入
        let inputValid = true
        for (let i in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].validate(bool => {
            !bool && (inputValid = false)
          })
        }
        if (!inputValid) {
          this.$Message.info('请检查录入信息')
          this.changeLoading()
          return
        }
        //校验文件上传
        let fileValid = true
        for (let i = 0, len = this.meterList.length; i < len; i++) {
          if (!this.meterList[i].curMeterDisplay && this.meterList[i].curMeterDisplay!==0) {
            if (!this.meterListCopy[i].meterPic) {
              fileValid = false
              break
            }
          }
        }
        if (!fileValid) {
          this.$Message.info('请检查上传文件')
          this.changeLoading()
          return
        }

        deliverysave(this.meterListCopy).then(res => {
          this.$emit('done')
          this.$Message.success('修改成功')
          this.isShow=false
        }).catch(error=>{
          this.changeLoading()
        })
        // this.changeLoading()

      },
      cancel() {

      }
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .inputwidth {
    width: 80%;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
